__turbopack_context__.v({
  "bottom": "styles-module-scss-module___wuWRW__bottom",
  "center": "styles-module-scss-module___wuWRW__center",
  "container": "styles-module-scss-module___wuWRW__container",
  "content": "styles-module-scss-module___wuWRW__content",
  "contentFirst": "styles-module-scss-module___wuWRW__contentFirst",
  "contentMediaStacked": "styles-module-scss-module___wuWRW__contentMediaStacked",
  "left": "styles-module-scss-module___wuWRW__left",
  "media": "styles-module-scss-module___wuWRW__media",
  "mediaFirst": "styles-module-scss-module___wuWRW__mediaFirst",
  "mediaItem": "styles-module-scss-module___wuWRW__mediaItem",
  "right": "styles-module-scss-module___wuWRW__right",
  "rotator": "styles-module-scss-module___wuWRW__rotator",
  "slideUp": "styles-module-scss-module___wuWRW__slideUp",
  "splitView": "styles-module-scss-module___wuWRW__splitView",
  "title": "styles-module-scss-module___wuWRW__title",
  "top": "styles-module-scss-module___wuWRW__top",
});
